<template>
	<article class='xbed-oms-content'>
		<section class='xbed-sub-title'>
			<span>PMS结算账单报表</span>
		</section>
		<section style='marginTop:20px'>
			<Form :model='formList' ref='formList'>
				<Row>
					<Col span='8'>
						<FormItem prop='' label='结算日期' :label-width='120'>
							<date-picker type='daterange' :model='formList.datePick' :value='formList.datePick' @on-change="datepick" :clearable="clearable" :editable="editable" :options="disabledDate" style='width:100%'></date-picker>
						</FormItem>
					</Col>
					<Col span='8'>
						<FormItem prop='' label='酒店' :label-width='120'>
							<Select v-model='formList.chainID'>
								<Option v-for='status in hotelName' :key='status.chainID' :value='status.chainID'>{{status.chainName}}</Option>
							</Select>
						</FormItem>
					</Col>

				</Row>
				<Row>
					<Col span="8">
						<FormItem prop='' label='支付方式' :label-width='120'>
							<Select v-model='formList.itemID'>
								<Option v-for='status in payStatus' :key='status.itemID' :value='status.itemID'>{{status.itemName}}</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem prop='' label='流水号' :label-width='120'>
							<Input type='number' v-model='formList.refCode'></Input>
						</FormItem>
					</Col>

				</Row>
				<Row>

					<Col span='5' offset="1">
						<FormItem>
							<Button type='primary' @click='queryPmsList' style='width:120px'>查询</Button>
						</FormItem>
					</Col>
					<Col span='5' v-if='isShowExportBtn'>
						<FormItem>
							<Button type='primary' @click='exprotExect' :loading="exportBtn">导出筛选结果</Button>
						</FormItem>
					</Col>
				</Row>
				<Table stripe :loading='orderListLoading' :width="tableWidth" height="550" :columns="orderList" :data="orderListData.list">
				</Table>
				<div style="margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="orderListData.total" :current="formList.page" :page-size="formList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</Form>
		</section>

	</article>
</template>
<script>
import Moment from 'moment';
import API from "../../api";
import Utils from '../../utils';
import Config from "../../config";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( 'vue-token' );
		this.env = Utils.findFromLocalStorage( 'env', 'dev' );
		this.userId = Utils.findFromLocalStorage( 'vue-userid' );
		this.tableWidth = window.screen.width - 235;
	},
	data() {
		return {
			exportBtn: false,
			clearable: false,
			editable: false,
			isShowExportBtn: true,
			tableWidth: 0,
			hotelName: [
				{
					chainName: '全部',
					chainID: '0'
				}
			],
			payStatus: [
				{
					itemName: '全部',
					itemID: '0'
				}, {
					itemName: '支付宝扫码支付',
					itemID: '6031'
				}, {
					itemName: '微信扫码支付',
					itemID: '6030'
				}, {
					itemName: '支付宝退款',
					itemID: '6021'
				}, {
					itemName: '微信退款',
					itemID: '6024'
				},
			],
			disabledDate: {
				disabledDate( date ) {
					return Moment( date ).isAfter( Moment() );
				}
			},
			formList: {
				itemID: '0', //科目ID
				chainID: '0',//酒店ID
				refCode: '',//流水号
				page: 1,
				pageSize: 10,
				datePick: [Moment().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ), Moment().format( 'YYYY-MM-DD' )],
			},
			orderListLoading: false,
			orderListData: [],
			orderList: [
				{
					title: '账单ID',
					key: 'folioID',
					minWidth: 100,
					align: 'center',
				},
				{
					title: '酒店名称',
					key: 'chainName',
					minWidth: 150,
					align: 'center',
				},
				{
					title: '房间号',
					key: 'roomNo',
					minWidth: 100,
					align: 'center',
				},
				{
					title: '科目ID',
					key: 'itemID',
					minWidth: 100,
					align: 'center',
					// render: (h,params)=>{
					//     let orderStatus = ['6021','6031','6024','6030'][params.row.itemID];
					//     return h('div',{},orderStatus)
					// }
				},
				{
					title: '科目名称',
					key: 'itemName',
					minWidth: 100,
					align: 'center',

				},
				{
					title: '二级科目名称',
					key: 'subItemName',
					minWidth: 100,
					align: 'center',

				},
				{
					title: '创建时间',
					key: 'createTime',
					minWidth: 200,
					align: 'center',

				},
				{
					title: '创建营业日',
					key: 'createAccDate',
					minWidth: 200,
					align: 'center',


				},
				{
					title: '结算金额',
					key: 'credit',
					minWidth: 100,
					align: 'center',
				},
				{
					title: '凭证号',
					key: 'refCode',
					minWidth: 150,
					align: 'center',
				},
				{
					title: '备注',
					key: 'remark',
					minWidth: 200,
					align: 'center',
				}
			]
		}
	},
	async mounted() {
		this.formList.loading = true;
		let params = this.initAjaxParams( '/api/oms/pmsCheckRepor' );
		let respData = ( await API.omsAPI[this.env].report.getPmsReports( params, this.token ) ).data;

		this.orderListData = respData;

		let hotelData = ( await API.omsAPI[this.env].report.getPmsChains( this.token ) ).data;
		this.hotelName = this.hotelName.concat( hotelData.list )

		// let payData = (await API.omsAPI[this.env].report.getPmsItems(this.token)).data;
		// this.payStatus = this.payStatus.concat(payData.list)
		this.formList.loading = false;
	},
	methods: {
		datepick( dataArr ) {
			this.formList.datePick = dataArr;
		},
		async changePage( pageIndex ) {
			this.formList.page = pageIndex;
			this.formList.loading = true;

			let params = this.initAjaxParams();
			let respData = ( await API.omsAPI[this.env].report.getPmsReports( params, this.token ) ).data;
			this.orderListData = respData;
			this.formList.loading = false;
		},
		async changePageSize( pageSize ) {
			this.formList.loading = true;
			this.formList.page = 1;
			this.formList.pageSize = pageSize;
			let params = this.initAjaxParams();
			let respData = ( await API.omsAPI[this.env].report.getPmsReports( params, this.token ) ).data;
			this.orderListData = respData;
			this.formList.loading = false;
		},

		async queryPmsList() {
			this.formList.page = 1;
			this.formList.loading = true;

			let params = this.initAjaxParams();
			let respData = ( await API.omsAPI[this.env].report.getPmsReports( params, this.token ) ).data;

			this.orderListData = respData;
			this.formList.loading = false;
		},
		exprotExect() {
			let url = Config[this.env].analysisUrl + `/excel/pmsCheckRepor?${ this.queryString( this.initAjaxParams( '' ) ) }`
			// window.open(url,"_blank")
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		},
		initAjaxParams( strUrl = '/api/oms/pmsCheckRepor' ) {
			let params = {
				url: strUrl,
				pageNum: this.formList.page,
				pageSize: this.formList.pageSize,
				chainID: this.formList.chainID == 0 ? '' : this.formList.chainID.toString(),
				itemID: this.formList.itemID == 0 ? '' : this.formList.itemID,
				refCode: this.formList.refCode,
				startDate: this.formList.datePick[0] + ' 00:00:00',
				endDate: this.formList.datePick[1] + ' 00:00:00'
			}
			for ( let item in params ) {
				if ( !params[item] ) delete params[item]
			}
			console.info( params )
			// if(this.formList.chainID>0){
			//     params.chainID = this.formList.chainID.toString()
			// }
			// if(this.formList.itemID>0){
			//     params.itemID = this.formList.itemID.toString()
			// }
			// if(this.formList.refCode){
			//     params.refCode = this.formList.refCode
			// }else{

			//     params.startDate = this.formList.datePick[0] + ' 00:00:00';
			//     params.endDate = this.formList.datePick[1] + ' 00:00:00';
			// }
			return params;
		},
		queryString( obj ) {
			let str = '';
			for ( const item in obj ) {
				if ( obj.hasOwnProperty( item ) ) {
					str += `${ item }=${ obj[item] }&`;
				}
			}
			return str.replace( /&$/, '' )
		},
		trimlrSpace( obj, name ) {
			obj[name] = obj[name].replace( /(^\s*)|(\D)|(\s*$)/img, "" )
		},
	},
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/report/pms-check-repors.vue